import React, { useState } from 'react';
import { FixedSizeList } from 'react-window';
import { BaseTextField } from '../../../BaseTextField/BaseTextField';
import SearchIcon from '@material-ui/icons/Search';
import { ITEM_HEIGHT, ITEM_PADDING_TOP } from '../helpers';
import { selectValuesType, TSelectOptions } from '../types';

type PSelectMenu = {
  children: React.ReactNode;
  selectMenuData: {
    options: TSelectOptions;
    OptionComponent: any;
    onClick: (newValue: selectValuesType) => void;
    selected: any;
    inputRef: React.Ref<any>;
  };
  withoutSearch?: boolean;
};
export type Ref = any;

// BaseMultiSelect and BaseSelect use react-window library for options rendering
// You can ask me "Why are you using this library?"
// It is because slow working of material-ui select when count of options are bigger than 100(+-)
// More details here https://www.npmjs.com/package/react-window
export const SelectMenu = React.forwardRef<Ref, PSelectMenu>((props, ref) => {
  const { selectMenuData, withoutSearch } = props;
  const { options, OptionComponent, inputRef } = selectMenuData;
  const [filteredOptions, setFilteredOptions] = useState(options);
  const handleRootClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const lowerInputValue = e.target.value.toLowerCase();
    setFilteredOptions(
      options.filter(
        (option) => option?.label.toLowerCase().indexOf(lowerInputValue) !== -1,
      ),
    );
  };

  const modifiedSelectMenuData = {
    ...selectMenuData,
    options: filteredOptions,
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div onClick={handleRootClick}>
      {!withoutSearch && (
        <div style={{ width: '100%', padding: '5px 16px' }}>
          <BaseTextField
            onChange={handleInputChange}
            InputProps={{
              inputRef,
              endAdornment: (
                <div style={{ padding: '0 11px', color: '#BEBEBE' }}>
                  <SearchIcon style={{ color: '#BEBEBE' }} />
                </div>
              ),
            }}
            fullWidth
          />
        </div>
      )}

      <FixedSizeList
        // @ts-ignore
        {...props}
        // Props that will be passed as data prop to OptionComponent
        itemData={modifiedSelectMenuData}
        height={ITEM_HEIGHT * 5 + ITEM_PADDING_TOP}
        itemCount={filteredOptions.length}
        itemSize={ITEM_HEIGHT}
        width="100%"
        style={{ minWidth: '250px' }}
        ref={ref}>
        {OptionComponent}
      </FixedSizeList>
    </div>
  );
});
